import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

interface Provincia {
  codiceIstat: string | null;
  nome: string | null;
  sigla: string | null;
}

export const useGetProvince = () => {
  const [province, setProvince] = useState<Provincia[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProvince = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/province`);
        setProvince(response.data);
      } catch (error) {
        setError("Impossibile recuperare le province");
      } finally {
        setLoading(false);
      }
    };

    fetchProvince();
  }, []);

  return { province, loading, error };
};

export default useGetProvince;